import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropContent from "../WaveDropContent";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import type { DropContentPresentation } from "../dropContentPresentation";
interface ParticipationDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onLongPress: () => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
export default function ParticipationDropContent(t0) {
  const $ = _c(15);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onLongPress,
    onDropContentClick,
    onQuoteClick,
    setLongPressTriggered,
    isCompetitionDrop: t1,
    contentPresentation: t2,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const contentPresentation = t2 === undefined ? "default" : t2;
  const hasTouch = useIsTouchDevice();
  let t3;
  if ($[0] !== activePartIndex || $[1] !== contentPresentation || $[2] !== drop || $[3] !== embedDepth || $[4] !== embedPath || $[5] !== hasTouch || $[6] !== isCompetitionDrop || $[7] !== maxEmbedDepth || $[8] !== onDropContentClick || $[9] !== onLongPress || $[10] !== onQuoteClick || $[11] !== quotePath || $[12] !== setActivePartIndex || $[13] !== setLongPressTriggered) {
    t3 = <div><WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={onLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={isCompetitionDrop} hasTouch={hasTouch} contentPresentation={contentPresentation} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} /></div>;
    $[0] = activePartIndex;
    $[1] = contentPresentation;
    $[2] = drop;
    $[3] = embedDepth;
    $[4] = embedPath;
    $[5] = hasTouch;
    $[6] = isCompetitionDrop;
    $[7] = maxEmbedDepth;
    $[8] = onDropContentClick;
    $[9] = onLongPress;
    $[10] = onQuoteClick;
    $[11] = quotePath;
    $[12] = setActivePartIndex;
    $[13] = setLongPressTriggered;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}